/**
 * @module
 */
 
const selector = '[data-js-career-subscribe]';
const careerSubscribe = function(el, app) {
    
    const $el = $(el);
    const $document = $(document);
    const emailSel = "[data-js-career-subscribe-email] input";
    const submitSel = "[data-js-career-subscribe-submit]";
    const init = function() {
        registerEvents();
    };
   
    
    // * remember that the dialog is cloned and placed into the pop-over, so initialising events on page load is pointless
    const registerEvents = function() {
        $(document).on('click',submitSel,subscribe);
        $(document).on('keyup',emailSel,function(ev) {
            if(event.keyCode == 13){
                subscribe();
            }
        });
    };
    
    const subscribe = function(ev) {
        const $popUp = $('[data-js-popup-stage]');
        const $email = $popUp.find( emailSel );
        var email = $email.val();
        if( Ge.Web20.Util.isEmail(email) ){
            app.trigger('msgGlobal',[jsDictionary.careerSubscribe.sending, "CareerSubscribeMessage","",true,true]);
            Ge.Web20.Util.callApi( nyUrls.ajaxCareerSubscribe, {
                email: email
            } ).then( function() {
                app.trigger('killAllPops');
                app.trigger('msgGlobal',[jsDictionary.careerSubscribe.complete, "CareerSubscribeMessage","ok",true,false]);
            });
        }
    };

    return {
        init: init()
    };
};

careerSubscribe.selector = selector;

export default careerSubscribe;
